import { useSelector } from "react-redux";
import { selectUser } from "../../redux/user/userSlice";
import { ConversationListContainer } from "../../features/conversation/ConversationListContainer";
import { MessagesScreen } from "../../features/conversation/messages/MessagesScreen";
import { useEffect } from "react";
import { retrieveConversationList, selectConversationList } from "../../redux/conversation/conversationListSlice";
import { useAppDispatch } from "../../app/hooks";
import { Box, Stack } from "@mui/material";
import { getElementHeight } from "../../app/utils";

interface AllConversationProps {
}

export const AllConversation = (props: AllConversationProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const conversationList = useSelector(selectConversationList);

    useEffect(() => {
        dispatch(retrieveConversationList({}));
    }, [conversationList, user]);


    const topHeight = getElementHeight("top-bar");
    const appNameHeight = 0; //getElementHeight("app-name");
    const appControlHeight = 0; //getElementHeight("app-control");
    const messageHeight = window.innerHeight - (2 + topHeight + appNameHeight + appControlHeight);

    return <Stack direction="row" spacing={0}>
        <Box id='contacts' sx={{ width: "400px", minWidth: "400px", maxWidth: "400px" }}>
            <ConversationListContainer height={messageHeight} />
        </Box>
        <Box id='conversation' sx={{ width: "100%" }}>
            <MessagesScreen height={messageHeight} />
        </Box>
    </Stack>;

};

